import { LegalPageLayout } from './LegalPageLayout';

export function CondizioniGeneraliPage() {
  return (
    <LegalPageLayout title="Condizioni Generali">
      <p className="mt-2 text-sm text-neutral-500">Ultima revisione: 7 Maggio 2026</p>
                  
                    <h2>CONDIZIONI GENERALI D&apos;USO DELLA PIATTAFORMA KLARO7</h2>
                    <p>
                      Klaro7 S.r.l.s. (di seguito &quot;Klaro7&quot; o la &quot;Società&quot;) mette a
                      disposizione degli Utenti una piattaforma online (&quot;Piattaforma&quot; o
                      &quot;Sito&quot;) che consente l&apos;incontro fra Utenti
                      (&quot;Utilizzatori&quot;) desiderosi di servizi di consulenza e operatori
                      (&quot;Operatori&quot; o &quot;Consulenti&quot;). Le presenti Condizioni Generali
                      d&apos;Uso (&quot;CGU&quot;) regolano l&apos;accesso e l&apos;utilizzo della
                      Piattaforma da parte degli Utenti.
                    </p>
      
                    <h2>DEFINIZIONI E OGGETTO</h2>
                    <p>
                      Ai fini delle presenti Condizioni, i termini di seguito elencati avranno il
                      seguente significato:
                    </p>
                    <ul>
                      <li>
                        <strong>Società:</strong> Klaro7 S.r.l.s., con sede in Via Prospero, 5b –
                        Grugliasco (TO), P.IVA 13344040012, titolare della Piattaforma.
                      </li>
                      <li>
                        <strong>Piattaforma:</strong> il sito web klaro7.com e le relative applicazioni
                        mobili/web.
                      </li>
                      <li>
                        <strong>Utilizzatore / Utente:</strong> il soggetto maggiorenne che si registra
                        per usufruire dei servizi.
                      </li>
                      <li>
                        <strong>Registrazione / Account / Sicurezza:</strong> Utente che usufruisce dei
                        servizi klaro7
                      </li>
                      <li>
                        <strong>Operatore / Consulente:</strong> il professionista autonomo (P.IVA) che
                        eroga la prestazione.
                      </li>
                      <li>
                        <strong>Servizio / Prestazione:</strong> l&apos;attività di intrattenimento o
                        consulenza spirituale erogata dall&apos;Operatore (chat, telefono, video).
                      </li>
                      <li>
                        <strong>Credito Ricaricato:</strong> l&apos;importo versato dall&apos;Utente
                        tramite strumenti di pagamento (Carte, PayPal, Bonifico).
                      </li>
                      <li>
                        <strong>Credito Bonus:</strong> il credito omaggio erogato dalla Società (es.
                        Benvenuto, Cashback, Promo) con scadenza e limiti d&apos;uso specifici.
                      </li>
                      <li>
                        <strong>Ricariche:</strong> l&apos;operazione di acquisto di Credito è necessaria
                        per accedere ai Servizi.
                      </li>
                      <li>
                        <strong>Cashback Mensile:</strong> il rimborso parziale in Credito Bonus
                        calcolato sul volume delle ricariche effettuate nel mese solare.
                      </li>
                    </ul>
      
                    <h2>ART. 1 - ACCETTAZIONE, REQUISITI E NATURA DEL SERVIZIO</h2>
                    <p>
                      <strong>1.1 Accettazione:</strong> La registrazione, l&apos;accesso o l&apos;uso
                      anche parziale della Piattaforma implica l&apos;accettazione integrale e
                      incondizionata delle presenti CGU, della Privacy Policy e del Codice Etico. In caso
                      di mancata accettazione, l&apos;Utilizzatore deve interrompere immediatamente
                      l&apos;uso del Servizio.
                    </p>
                    <p>
                      <strong>1.2 Requisiti d&apos;Età e Veridicità:</strong> L&apos;utilizzo della
                      Piattaforma è riservato esclusivamente a persone fisiche maggiorenni (18+).
                      L&apos;Utilizzatore garantisce la veridicità dei dati forniti in fase di
                      registrazione e si impegna a mantenerli costantemente aggiornati.
                    </p>
                    <p>
                      <strong>1.3 Oggetto e Finalità (Esclusione di Responsabilità):</strong> I servizi
                      offerti su Klaro7 hanno finalità esclusivamente di intrattenimento, curiosità e
                      supporto motivazionale. L&apos;Utilizzatore riconosce e accetta espressamente che:
                    </p>
                    <ul>
                      <li>
                        I consulti non costituiscono, in nessun caso, consulenza professionale medica,
                        legale, finanziaria, psicologica o terapeutica.
                      </li>
                      <li>
                        Le informazioni ricevute non possono sostituire il parere o l&apos;intervento di
                        professionisti qualificati.
                      </li>
                      <li>
                        Klaro7 non garantisce la veridicità o l&apos;accuratezza delle previsioni,
                        trattandosi di interpretazioni soggettive basate su discipline esoteriche e
                        spirituali prive di fondamento scientifico.
                      </li>
                    </ul>
                    <p>
                      <strong>1.4 Divieti Categorici (Salute e Minori):</strong> È fatto divieto assoluto
                      di richiedere consulti riguardanti la salute, diagnosi mediche, prognosi,
                      gravidanze, o che coinvolgano, direttamente o indirettamente, soggetti minori di
                      anni 18.
                    </p>
                    <p>
                      <strong>1.5 Divieto di Disintermediazione (Contatto Privato):</strong> È
                      severamente vietato all&apos;Utilizzatore richiedere agli Operatori, o fornire loro,
                      contatti personali (numeri di telefono, email, profili social o indirizzi fisici)
                      per proseguire i consulti al di fuori della Piattaforma. Qualsiasi violazione
                      comporterà la chiusura immediata dell&apos;Account e l&apos;incameramento del credito
                      residuo a titolo di penale risarcitoria, fatto salvo il diritto di Klaro7 al
                      risarcimento del maggior danno.
                    </p>
                    <p>
                      <strong>1.6 Autonomia dei Consulenti:</strong> Gli Operatori (o Consulenti) presenti
                      sulla Piattaforma Klaro7 sono professionisti esperti che operano in regime di totale
                      autonomia e indipendenza. Essi non sono dipendenti, né agenti, né rappresentanti di
                      Klaro7
                    </p>
                    <p>
                      <strong>1.7 Titolarità e Regime Fiscale:</strong> Ogni Operatore agisce in qualità
                      di libero professionista, titolare di propria Partita IVA (o regime fiscale
                      equivalente nel proprio paese di residenza), ed è l&apos;unico responsabile per
                      l&apos;adempimento di ogni obbligo fiscale, previdenziale e assicurativo derivante
                      dall&apos;attività di consulenza prestata sulla Piattaforma.
                    </p>
                    <p>
                      <strong>1.8 Responsabilità delle Opinioni:</strong> Le opinioni, le interpretazioni
                      e le consulenze fornite dagli Operatori sono strettamente personali e non riflettono
                      necessariamente il pensiero o la posizione di Klaro7. L&apos;Operatore è
                      l&apos;unico responsabile della qualità e dei contenuti della propria prestazione,
                      che deve comunque restare nell&apos;ambito dell&apos;intrattenimento e del supporto
                      motivazionale.
                    </p>
                    <p>
                      <strong>1.9 Ruolo di Klaro7:</strong> Klaro7 agisce esclusivamente come fornitore
                      dell&apos;infrastruttura tecnologica (Marketplace) volta a mettere in contatto
                      l&apos;Utilizzatore con il Consulente autonomo. Klaro7 non esercita alcun potere di
                      direzione o coordinamento sulle modalità tecniche e sulle interpretazioni fornite
                      dal Consulente durante le sessioni private.
                    </p>
      
                    <h2>ART. 2 - REGISTRAZIONE, ACCOUNT E SICUREZZA</h2>
                    <p>
                      <strong>2.1 Creazione dell&apos;Account:</strong> Per accedere ai Servizi,
                      l&apos;Utilizzatore deve completare la procedura di registrazione fornendo dati
                      veritieri, aggiornati e completi. Ogni Utilizzatore può essere titolare di un solo
                      ed unico Account. È severamente vietata la creazione di account multipli riconducibili
                      alla stessa persona fisica.
                    </p>
                    <p>È consentita una sola registrazione per persona fisica.</p>
                    <p>
                      È severamente vietata la creazione di account multipli riconducibili alla stessa
                      persona, anche mediante l&apos;utilizzo di:
                    </p>
                    <ul>
                      <li>indirizzi e-mail differenti;</li>
                      <li>numeri di telefono diversi;</li>
                      <li>metodi di pagamento differenti;</li>
                      <li>dispositivi differenti.</li>
                    </ul>
                    <p>
                      La creazione di account multipli finalizzata all&apos;ottenimento reiterato di bonus
                      o vantaggi economici costituisce abuso contrattuale.
                    </p>
                    <p>
                      <strong>
                        2.2 Credenziali di Accesso e Gestione del Numero di Telefono:
                      </strong>{' '}
                      L&apos;Utilizzatore è l&apos;unico responsabile della custodia e della riservatezza
                      delle proprie credenziali (E-mail e Password). Qualsiasi attività effettuata tramite
                      l&apos;Account sarà attribuita all&apos;Utilizzatore titolare. In caso di smarrimento
                      o sospetto uso non autorizzato, l&apos;Utilizzatore deve informare immediatamente
                      Klaro7 all&apos;indirizzo assistenza@klaro7.it.
                    </p>
                    <p>
                      <strong>Modifica del numero:</strong> L&apos;Utente che necessiti di modificare il
                      numero di cellulare associato al proprio Account (es. in caso di smarrimento o cambio
                      SIM) deve inviare una richiesta documentata a assistenza@klaro7.it.
                    </p>
                    <p>
                      <strong>Nessun Bonus Duplicato:</strong> La variazione del numero di telefono su un
                      account esistente, o la creazione di un nuovo account con un numero differente da
                      parte dello stesso Utente, non darà in alcun caso diritto a ricevere nuovamente il
                      Bonus di Benvenuto o altri vantaggi già fruiti.
                    </p>
                    <p>
                      <strong>Verifica Identità:</strong> In caso di cambio numero, la Società si riserva
                      il diritto di richiedere ulteriore prova dell&apos;identità dell&apos;Utente per
                      prevenire tentativi di furto dell&apos;account o elusione delle norme anti-abuso.
                    </p>
      
                    <h2>ART. 3 - REGISTRAZIONE E BONUS DI BENVENUTO &quot;7 MINUTI GRATIS&quot;</h2>
                    <p>
                      <strong>3.1 Procedura di Verifica OTP:</strong> Al fine di garantire la sicurezza
                      della Piattaforma e l&apos;autenticità delle utenze, il completamento della procedura
                      di iscrizione è subordinato alla verifica del numero di telefonia mobile
                      dell&apos;Utente. Il sistema invierà un codice univoco OTP (One Time Password) via
                      SMS che l&apos;Utente dovrà inserire per attivare definitivamente l&apos;account.
                    </p>
                    <p>Klaro7 si riserva il diritto di:</p>
                    <ul>
                      <li>rifiutare numeri virtuali o temporanei (VoIP);</li>
                      <li>bloccare numeri già associati ad altri account.</li>
                    </ul>
                    <p>
                      L&apos;Utente accetta l&apos;utilizzo di sistemi automatizzati di prevenzione e
                      rilevazione frodi, inclusi controlli su:
                    </p>
                    <ul>
                      <li>indirizzo IP,</li>
                      <li>dispositivi (device recognition/fingerprinting),</li>
                      <li>metodi di pagamento,</li>
                      <li>comportamenti anomali.</li>
                    </ul>
                    <p>
                      L&apos;Utente riconosce che la verifica tramite OTP è un requisito essenziale per la
                      prevenzione delle frodi e per l&apos;assegnazione dei Bonus di Benvenuto. La Società
                      si riserva il diritto di negare l&apos;erogazione del bonus qualora il numero di
                      telefono risulti non verificabile o già presente nei sistemi.
                    </p>
                    <p>
                      <strong>3.2 Bonus di Benvenuto &quot;7 Minuti Gratis&quot;:</strong> Klaro7 offre a
                      ogni nuovo Utente regolarmente verificato un Bonus di Benvenuto consistente in 7
                      minuti di consulto gratuito.
                    </p>
                    <ul>
                      <li>
                        <strong>Modalità di Erogazione:</strong> Il Bonus viene accreditato
                        automaticamente sotto forma di &quot;Credito Bonus&quot; subito dopo la validazione
                        dell&apos;OTP.
                      </li>
                      <li>
                        <strong>Utilizzo:</strong> L&apos;Utente ha piena libertà di utilizzare i 7 minuti
                        immediatamente dopo l&apos;iscrizione o in un momento successivo, a sua discrezione.
                      </li>
                      <li>
                        <strong>Scelta del Consulente:</strong> Il Bonus è valido per consulti con
                        qualsiasi Operatore presente sulla Piattaforma, salvo diversa indicazione (es.
                        Operatori esclusi da promozioni specifiche).
                      </li>
                      <li>
                        <strong>Unicità del Bonus (Anti-Abuso):</strong> Il Bonus è strettamente limitato
                        a un solo account per persona fisica e per numero di cellulare. Qualora i sistemi
                        di controllo di Klaro7 rilevino tentativi di aggirare tale limite (es. utilizzo di
                        più numeri per la stessa persona, account duplicati, identità fittizie), la Società
                        procederà all&apos;immediata chiusura di tutti gli account coinvolti e
                        all&apos;annullamento di qualsiasi credito, senza preavviso.
                      </li>
                      <li>
                        <strong>Scadenza:</strong> Salvo diversa indicazione, il Bonus di Benvenuto deve
                        essere utilizzato entro 20 giorni dalla data di attivazione dell&apos;account.
                      </li>
                    </ul>
                    <p>Il Bonus:</p>
                    <ul>
                      <li>è personale e non trasferibile;</li>
                      <li>è riconosciuto una sola volta per persona fisica e per numero di telefono;</li>
                      <li>è erogato come Credito Bonus;</li>
                      <li>deve essere utilizzato entro 20 giorni;</li>
                      <li>non è convertibile in denaro.</li>
                    </ul>
                    <p>
                      In caso di rilevazione di tentativi di aggiramento del limite di unicità, Klaro7
                      procederà alla chiusura degli account coinvolti e all&apos;annullamento dei crediti
                      bonus.
                    </p>
                    <p>
                      Le iniziative promozionali costituiscono strumenti commerciali variabili nel tempo e
                      non configurano un diritto acquisito permanente per l&apos;utente.
                    </p>
                    <p>
                      <strong>3.3 Divieto di Cessione:</strong> L&apos;Account è strettamente personale e
                      non cedibile a terzi. L&apos;Utilizzatore si impegna a non permettere a terzi (siano
                      essi amici, familiari o conoscenti) di utilizzare il proprio Account per usufruire
                      dei consulti.
                    </p>
                    <p>
                      <strong>3.4 Verifica dell&apos;Identità:</strong> Klaro7 si riserva il diritto, in
                      qualsiasi momento e a propria discrezione (specialmente in presenza di ricariche
                      elevate o transazioni sospette), di richiedere all&apos;Utilizzatore una copia di un
                      documento d&apos;identità valido. Il rifiuto di fornire tale documentazione comporterà
                      la sospensione immediata dell&apos;Account fino a verifica avvenuta.
                    </p>
                    <p>
                      <strong>3.5 Sospensione e Chiusura (Power of Termination):</strong> Klaro7 si riserva
                      il diritto unilaterale di sospendere o chiudere l&apos;Account dell&apos;Utilizzatore,
                      senza preavviso e con effetto immediato, nei seguenti casi:
                    </p>
                    <ul>
                      <li>Violazione di una qualsiasi clausola delle presenti CGU.</li>
                      <li>Utilizzo di sistemi automatici (bot, crawler) per accedere alla Piattaforma.</li>
                      <li>
                        Comportamenti volti a manipolare il sistema di recensioni o il programma Referral.
                      </li>
                      <li>
                        Inattività dell&apos;Account superiore a 12 mesi (previa comunicazione via e-mail
                        con 30 giorni di preavviso).
                      </li>
                    </ul>
                    <p>
                      <strong>3.6 Conseguenze della Chiusura:</strong> In caso di chiusura
                      dell&apos;Account per violazione contrattuale (es. frodi, insulti o tentativi di
                      disintermediazione) eventuali crediti bonus o promozionali verranno annullati.
                    </p>
                    <p>
                      Il credito acquistato potrà essere trattenuto esclusivamente nei casi di frode
                      accertata, fatto salvo il diritto al risarcimento del danno.
                    </p>
      
                    <h2>ART. 4 - MODALITÀ DI EROGAZIONE DELLE PRESTAZIONI</h2>
                    <p>
                      <strong>4.1 Tipologie di Consulto:</strong> Il Servizio si articola in tre modalità
                      principali, ognuna con logiche di tariffazione specifiche:
                    </p>
                    <ul>
                      <li>
                        <strong>Consulto Telefonico:</strong> L&apos;Utilizzatore avvia la chiamata tramite
                        la Piattaforma. Il costo viene scalato dal Credito in tempo reale, per ogni minuto
                        di conversazione iniziato.
                      </li>
                      <li>
                        <strong>Consulto via Chat:</strong> Uno scambio di messaggi in tempo reale. Il
                        sistema scala il credito in base alla durata della sessione no per singolo
                        messaggio, a seconda della tariffa impostata dall&apos;Operatore.(calcolato sempre
                        al minuto).
                      </li>
                      <li>
                        <strong>Consulto Videochiamata:</strong> Una sessione in streaming audio-video.
                        Richiede una connessione stabile e il costo è calcolato al minuto.
                      </li>
                    </ul>
                    <p>
                      Le tariffe applicabili sono sempre visibili prima dell&apos;avvio del consulto e non
                      possono essere modificate durante una sessione già iniziata.
                    </p>
                    <p>
                      Eventuali problemi tecnici imputabili alla Piattaforma potranno essere oggetto di
                      verifica e, se accertati, dar luogo a eventuale riaccredito proporzionale.
                    </p>
                    <p>Problemi di connessione imputabili all&apos;Utente non danno diritto a rimborso.</p>
                    <p>
                      <strong>4.2 Unità di Misura e Scatti:</strong> Salvo diversa indicazione, il costo
                      dei Servizi è calcolato al minuto. La tariffazione è anticipata: allo scoccare di
                      ogni nuovo minuto di conversazione/connessione, verrà prelevato dal Credito
                      l&apos;importo corrispondente al minuto intero.
                    </p>
                    <p>
                      <strong>4.3 Durata e Interruzione Automatica:</strong> Il consulto prosegue fino a
                      quando:
                    </p>
                    <ol>
                      <li>L&apos;Utilizzatore o l&apos;Operatore decidono di terminare la comunicazione.</li>
                      <li>
                        Il Credito residuo dell&apos;Utilizzatore si esaurisce. In questo caso, la
                        Piattaforma interromperà automaticamente la comunicazione per evitare debiti o
                        scoperti.
                      </li>
                    </ol>
                    <p>
                      <strong>4.4 Gestione del Tempo e Countdown:</strong>
                    </p>
                    <ul>
                      <li>
                        <strong>Visualizzazione:</strong> Durante l&apos;intera sessione, sia l&apos;Utente
                        che l&apos;Operatore visualizzeranno un countdown (cronometro a scalare) in tempo
                        reale.
                      </li>
                      <li>
                        <strong>Fine Sessione:</strong> Il sistema invierà un avviso sonoro o visivo 2
                        minuti prima della scadenza e interromperà automaticamente la connessione allo
                        scoccare dello zero per garantire la puntualità degli impegni successivi.
                      </li>
                    </ul>
                    <p>
                      <strong>4.5 Responsabilità Tecnica dell&apos;Erogazione:</strong> Klaro7 mette a
                      disposizione la tecnologia di connessione. L&apos;Utilizzatore è responsabile di
                      verificare che il proprio dispositivo e la propria connessione internet/telefonica
                      siano idonei. Eventuali cali di segnale lato Utilizzatore non daranno diritto a
                      rimborsi per i minuti già scalati.
                    </p>
      
                    <h2>ART. 5 - RICARICHE, CREDITO E TARIFFE</h2>
                    <p>
                      <strong>5.1 Funzionamento del Credito:</strong> L&apos;accesso ai Servizi avviene
                      tramite l&apos;acquisto preventivo di &quot;Credito Piattaforma&quot; (Ricariche). Il
                      credito non ha una scadenza fissa, salvo inattività dell&apos;account superiore a 12
                      mesi, e non è convertibile in denaro contante.
                    </p>
                    <p>
                      <strong>5.2 Bonus Prima Ricarica (Welcome Bonus):</strong> Per incentivare la prova
                      del Servizio, Klaro7 può offrire Bonus sulla prima ricarica.
                    </p>
                    <ul>
                      <li>
                        L&apos;Utilizzatore riconosce che il Bonus e la relativa tariffa agevolata associata
                        sono validi esclusivamente per la prima transazione e fino a esaurimento del credito
                        acquistato in tale occasione.
                      </li>
                      <li>
                        Klaro7 si riserva il diritto di annullare i Bonus qualora venga accertata la
                        creazione di account multipli da parte dello stesso soggetto per usufruire
                        ripetutamente dell&apos;offerta.
                      </li>
                      <li>
                        L&apos;Utente riconosce che la verifica tramite OTP è un requisito essenziale per la
                        prevenzione delle frodi e per l&apos;assegnazione dei Bonus di Benvenuto. La Società
                        si riserva il diritto di negare l&apos;erogazione del bonus qualora il numero di
                        telefono risulti non verificabile o già presente nei sistemi.
                      </li>
                    </ul>
                    <p>
                      <strong>5.3 Tariffe Post-Promozionali (Seconda Ricarica e Successive):</strong> Dalla
                      seconda ricarica in poi, o una volta esaurito il credito promozionale, si applicano
                      le tariffe standard.
                    </p>
                    <ul>
                      <li>
                        <strong>Tariffazione Dinamica:</strong> L&apos;Utilizzatore accetta che ogni
                        Operatore ha la facoltà di impostare e modificare la propria tariffa al minuto in
                        base alla propria esperienza, qualifica ( Silver, Gold, Diamond ) o promozioni
                        temporanee.
                      </li>
                      <li>
                        <strong>Verifica della Tariffa:</strong> Prima di avviare ogni consulto,
                        l&apos;Utilizzatore ha l&apos;obbligo di verificare la tariffa applicata
                        dall&apos;Operatore scelto, chiaramente indicata sul profilo dello stesso.
                        L&apos;avvio della chiamata/chat costituisce accettazione della tariffa esposta in
                        quel determinato momento.
                      </li>
                    </ul>
                    <p>
                      <strong>5.4 Modalità di Pagamento e Sicurezza:</strong> I pagamenti avvengono tramite
                      gateway sicuri (PayPal, Stripe, Carte di Credito). Klaro7 non accede né memorizza i
                      dati finanziari dell&apos;Utilizzatore.
                    </p>
                    <ul>
                      <li>
                        In caso di Bonifico Bancario, il credito verrà accreditato manualmente solo dopo
                        l&apos;effettivo ricevimento della somma sul conto corrente della Società (tempi
                        tecnici: 1-3 giorni lavorativi).
                      </li>
                    </ul>
                    <p>
                      <strong>5.5 Esaurimento Credito e Interruzione:</strong> Qualora il credito residuo
                      scenda a zero durante un consulto, la connessione verrà interrotta automaticamente
                      dal sistema. L&apos;Utilizzatore potrà riprendere la sessione solo dopo aver
                      effettuato una nuova ricarica alle tariffe correnti dell&apos;Operatore.
                    </p>
      
                    <h2>ART. 6 - ACQUISTO E OFFERTE PROMOZIONALI</h2>
                    <p>
                      <strong>6.1 Modalità di Acquisto:</strong> L&apos;accesso ai Servizi avviene tramite
                      l&apos;acquisto di Ricariche/Credito che verranno scalate in base alla tariffa
                      dell&apos;Operatore scelto.
                    </p>
                    <p>
                      <strong>
                        6.2 Piattaforme di Pagamento (PayPal, Stripe, Carte di Credito/Debito):
                      </strong>{' '}
                      I pagamenti per l&apos;acquisto di Credito/Ricariche avvengono tramite gateway sicuri
                      di terze parti (es. PayPal, Stripe). Klaro7 non memorizza i dati della carta di
                      credito o le credenziali di accesso ai servizi di pagamento dell&apos;Utilizzatore.
                      L&apos;Utilizzatore garantisce di avere il pieno diritto di utilizzare lo strumento
                      di pagamento prescelto. In caso di transazioni sospette, Klaro7 si riserva il diritto
                      di sospendere l&apos;erogazione del Servizio e richiedere documenti identificativi a
                      tutela della sicurezza antifrode.
                    </p>
                    <p>
                      <strong>6.3 Sicurezza dei Pagamenti:</strong> I pagamenti avvengono tramite gateway
                      sicuri di terze parti (es. PayPal, Stripe). Klaro7 non memorizza i dati delle carte
                      di credito degli Utilizzatori. L&apos;Utilizzatore è responsabile della legittimità
                      dello strumento di pagamento utilizzato.
                    </p>
                    <p>
                      <strong>6.4 Pagamenti tramite Bonifico Bancario:</strong> In caso di acquisto crediti
                      tramite Bonifico Bancario, l&apos;accredito sulla Piattaforma non sarà immediato.
                      L&apos;Utilizzatore riconosce che il Credito verrà caricato sul proprio Account solo
                      al momento dell&apos;effettivo ricevimento dei fondi presso l&apos;istituto bancario
                      di Klaro7 (solitamente 1-3 giorni lavorativi). È necessario indicare nella causale del
                      bonifico il proprio &apos;ID Utente&apos; o la &apos;Email di Registrazione&apos; per
                      permettere la corretta associazione del credito.
                    </p>
                    <p>
                      <strong>6.5 Divieto di Contestazione Ingiustificata (Anti-Chargeback):</strong>{' '}
                      L&apos;Utilizzatore si impegna a contattare preventivamente Klaro7 tramite il servizio
                      clienti (assistenza@klaro7.it.) per qualsiasi richiesta di chiarimento relativa a
                      pagamenti, ricariche o addebiti, prima di attivare procedure di contestazione presso
                      il proprio istituto bancario o circuito di pagamento.
                    </p>
                    <p>
                      L&apos;avvio di una procedura di chargeback o contestazione formale presso
                      l&apos;emittente della carta o il provider di pagamento, in assenza di fondati motivi
                      di frode o utilizzo non autorizzato, costituisce grave violazione contrattuale.
                    </p>
                    <p>In caso di chargeback:</p>
                    <ul>
                      <li>l&apos;Account sarà immediatamente sospeso in via cautelativa;</li>
                      <li>
                        eventuali crediti residui (inclusi crediti bonus) saranno bloccati fino alla
                        definizione della controversia;
                      </li>
                      <li>
                        qualora la contestazione risulti infondata o venga respinta dal circuito di
                        pagamento, Klaro7 si riserva il diritto di:
                        <ul>
                          <li>
                            addebitare all&apos;Utente eventuali costi bancari e commissioni applicate dal
                            provider;
                          </li>
                          <li>richiedere il risarcimento degli eventuali danni subiti;</li>
                          <li>limitare o impedire future ricariche tramite lo stesso metodo di pagamento.</li>
                        </ul>
                      </li>
                    </ul>
                    <p>
                      Resta salvo il diritto dell&apos;Utente di agire nei casi di effettivo utilizzo
                      fraudolento da parte di terzi non autorizzati.
                    </p>
                    <p>
                      <strong>6.6 Rinuncia al Diritto di Recesso:</strong> Ai sensi dell&apos;art. 59, lett.
                      a) e o) del Codice del Consumo (D.Lgs. 206/2005), l&apos;Utilizzatore accetta
                      espressamente che l&apos;esecuzione del Servizio inizi immediatamente con l&apos;invio
                      della richiesta di consulto o l&apos;avvio della chiamata/chat. Pertanto,
                      l&apos;Utilizzatore riconosce e accetta di perdere il diritto di recesso di 14 giorni
                      una volta che la prestazione è iniziata o il credito è stato parzialmente o totalmente
                      consumato.
                    </p>
                    <p>
                      <strong>6.7 Bonus di Benvenuto (Welcome Gift):</strong> Ogni nuovo Utente riceverà,
                      al completamento della registrazione e previa verifica obbligatoria del numero di
                      cellulare (OTP), un bonus omaggio di 7 minuti.
                    </p>
                    <ul>
                      <li>
                        <strong>Validità:</strong> Il bonus ha una durata di 20 (venti) giorni
                        dall&apos;erogazione.
                      </li>
                      <li>
                        <strong>Limitazioni:</strong> È consentito un solo bonus per persona fisica/nucleo
                        familiare/indirizzo IP/numero di telefono/opt Klaro7 si riserva il diritto di
                        annullare i bonus in caso di registrazioni multiple sospette.
                      </li>
                    </ul>
                    <p>
                      <strong>6.8 Offerta Bonus Prima Ricarica:</strong> Al momento della prima ricarica,
                      l&apos;Utente ha diritto a un credito aggiuntivo (Bonus) secondo la seguente
                      struttura, che include una tariffa promozionale fissa di 0,99€ al minuto fino
                      all&apos;esaurimento del credito totale (Ricarica + Bonus):
                    </p>
                    <table>
                      <thead>
                        <tr>
                          <th>Ricarica Base (€)</th>
                          <th>Credito Bonus (€)</th>
                          <th>Credito Totale Utile (€)</th>
                          <th>Costo Promozionale al Minuto</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>10,00</td>
                          <td>7,00</td>
                          <td>17,00</td>
                          <td>0,99€</td>
                        </tr>
                        <tr>
                          <td>30,00</td>
                          <td>20,00</td>
                          <td>50,00</td>
                          <td>0,99€</td>
                        </tr>
                        <tr>
                          <td>50,00</td>
                          <td>30,00</td>
                          <td>80,00</td>
                          <td>0,99€</td>
                        </tr>
                      </tbody>
                    </table>
                    <p>
                      <strong>Validità del Tasso Promozionale:</strong> Il costo di 0,99€ al minuto è
                      applicabile esclusivamente fino all&apos;esaurimento del Credito Totale (Base + Bonus)
                      generato dalla prima ricarica. Successivamente, verrà applicata la tariffa standard
                      del Consulente selezionato (come indicato nel suo profilo).L&apos;Utente è responsabile
                      di verificare la tariffa applicata prima di avviare il consulto.
                    </p>
      
                    <h2>ART. 7 - PROGRAMMA FEDELTÀ &quot;KLARO7 REWARD&quot;</h2>
                    <p>
                      <strong>7.1 Cashback Mensile (Il Giorno 7 di Klaro7):</strong> Il giorno 7 di ogni
                      mese, Klaro7 accredita automaticamente un bonus fedeltà calcolato sulla spesa totale
                      effettuata dall&apos;Utente nel mese solare precedente,sulle ricariche a tariffa
                      standard, secondo i seguenti scaglioni:
                    </p>
                    <ul>
                      <li>Spesa € 100,00 - € 149,99: € 7,00 Bonus</li>
                      <li>Spesa € 150,00 - € 299,99: € 14,00 Bonus</li>
                      <li>Spesa € 300,00 - € 499,99: € 21,00 Bonus</li>
                      <li>Spesa € 500,00 - € 699,99: € 28,00 Bonus</li>
                      <li>Spesa € 700,00 - € 999,99: € 35,00 Bonus</li>
                      <li>Spesa oltre € 1.000,00 € 70,00 Bonus</li>
                    </ul>
                    <p>
                      <strong>Programma Cashback Mensile:</strong> Klaro7 premia la fedeltà degli
                      Utilizzatori attraverso un sistema di Cashback calcolato sul volume delle ricariche
                      effettuate nel mese solare.
                    </p>
                    <ul>
                      <li>
                        <strong>Periodo di Calcolo (Ciclo Mensile):</strong> Ai fini del raggiungimento
                        delle soglie di Cashback, il conteggio delle ricariche inizia tassativamente alle
                        ore 00:00 del primo giorno del mese e termina alle ore 23:59 dell&apos;ultimo giorno
                        del mese solare. Farà fede esclusivamente l&apos;orario di sistema della Piattaforma
                        (CET/CEST).
                      </li>
                      <li>
                        <strong>Validità delle Ricariche:</strong> Concorrono al calcolo del Cashback solo
                        le ricariche effettivamente completate e incassate entro il termine del ciclo
                        mensile. Le ricariche tramite Bonifico Bancario saranno conteggiate nel mese in cui
                        avviene l&apos;effettivo accredito e la successiva validazione manuale da parte di
                        Klaro7, indipendentemente dalla data in cui l&apos;Utilizzatore ha disposto
                        l&apos;ordine di bonifico.
                      </li>
                      <li>
                        <strong>Esclusioni:</strong> Il Credito Bonus (ottenuto tramite promozioni o altri
                        cashback) non genera ulteriore cashback e non concorre al raggiungimento delle
                        soglie mensili.
                      </li>
                      <li>
                        <strong>Erogazione e Scadenza:</strong> Il Cashback maturato verrà accreditato sotto
                        forma di &quot;Credito Bonus&quot; entro i primi 7 giorni del mese successivo. Tale
                        credito bonus, come previsto dalla Policy Bonus, ha una validità di 20 giorni
                        dall&apos;erogazione, decorsi i quali non sarà più utilizzabile.
                      </li>
                      <li>
                        <strong>Soglie e Percentuali:</strong> Le soglie di spesa necessarie per attivare il
                        Cashback e le relative percentuali di rimborso sono pubblicate e aggiornate
                        periodicamente nella sezione &quot;Le Mie Promozioni&quot; del Sito. Klaro7 si
                        riserva il diritto di modificare o sospendere il programma Cashback con un preavviso
                        di 30 giorni.
                      </li>
                    </ul>
                    <p>
                      <strong>7.2 Bonus Compleanno:</strong> In occasione del compleanno comunicato in fase
                      di registrazione, l&apos;Utente riceverà un bonus di € 10,00.
                    </p>
                    <ul>
                      <li>
                        <strong>Requisiti:</strong> Il bonus è erogato solo agli Utenti che hanno effettuato
                        almeno una ricarica a pagamento negli ultimi 6 mesi.
                      </li>
                      <li>
                        <strong>Scadenza:</strong> Il Bonus Compleanno ha una validità di 20 (venti) giorni
                        dall&apos;erogazione.
                      </li>
                    </ul>
                    <p>
                      <strong>7.3 Disciplina Generale dei Bonus:</strong>
                    </p>
                    <ul>
                      <li>
                        <strong>Natura:</strong> I crediti erogati a titolo di Bonus (Benvenuto, Compleanno,
                        Cashback) sono sconti promozionali prepagati da Klaro7 e non hanno valore monetario
                        reale.
                      </li>
                      <li>
                        <strong>Priorità di Consumo:</strong> Durante i consulti, il sistema scalerà prima
                        il credito Bonus e successivamente il credito effettivo del proprio borsellino.
                      </li>
                      <li>
                        <strong>Inconvertibilità:</strong> I crediti Bonus non sono in alcun caso
                        rimborsabili, convertibili in denaro contante, né cedibili a terzi.
                      </li>
                      <li>
                        <strong>Decadenza:</strong> In caso di chiusura dell&apos;account o esercizio del
                        diritto di recesso, i crediti Bonus presenti sul borsellino verranno annullati senza
                        diritto ad alcun rimborso o compensazione.
                      </li>
                    </ul>
                    <p>
                      <strong>7.4 Bonus &quot;Porta un Amico&quot;</strong> Funzionamento: Ogni
                      Utilizzatore dispone di un link/codice univoco. Per ogni nuovo utente
                      (&quot;Invitato&quot;) che si registra tramite tale link e conclude la sua prima
                      ricarica a pagamento (minimo € 10,00), l&apos;Utilizzatore riceverà un Bonus Omaggio
                      di € 7,00 ( valido 20 giorni ).
                    </p>
                    <p>
                      <strong>Limitazioni:</strong> Il Bonus Referral non è convertibile in denaro e può
                      essere utilizzato solo per consulti sulla Piattaforma.
                    </p>
                    <p>
                      <strong>Anti-Frode:</strong> Klaro7 si riserva di annullare i Bonus e chiudere gli
                      account in caso di abuso del programma (es. auto-inviti, creazione di account multipli
                      dallo stesso indirizzo IP o utilizzo di carte di pagamento identiche per account
                      diversi).
                    </p>
                    <p>
                      <strong>7.5 Acquisto Crediti e Rinuncia: al Recesso</strong> Ai sensi dell&apos;art.
                      59, lett. a) e o) del Codice del Consumo (D.Lgs. 206/2005), l&apos;Utilizzatore
                      accetta espressamente che l&apos;esecuzione del Servizio inizi immediatamente con
                      l&apos;avvio del consulto (telefonico o chat). Pertanto, con l&apos;inizio della
                      prestazione, l&apos;Utilizzatore decade dal diritto di recesso una volta che il
                      servizio è stato completamente prestato o il credito consumato. Eventuali crediti
                      residui non utilizzati potranno essere rimborsati entro 14 giorni dall&apos;acquisto, a
                      condizione che non sia stata iniziata alcuna sessione di consulto.
                    </p>
                    <p>
                      Le iniziative promozionali costituiscono strumenti commerciali variabili nel tempo e
                      non configurano un diritto acquisito permanente per l&apos;utente.
                    </p>
      
                    <h2>ART. 8 - SISTEMA DI MESSAGGISTICA (CONSULENTI OFFLINE)</h2>
                    <p>
                      <strong>8.1 Finalità del servizio:</strong> La piattaforma mette a disposizione degli
                      utenti un sistema di messaggistica utilizzabile esclusivamente per contattare
                      consulenti non disponibili al momento (offline), al fine di richiedere informazioni
                      sulla loro futura disponibilità.
                    </p>
                    <p>
                      <strong>8.2 Limitazioni di utilizzo:</strong> Il servizio di messaggistica è soggetto
                      alle seguenti condizioni:
                    </p>
                    <ul>
                      <li>
                        l&apos;utente può inviare messaggi esclusivamente ai consulenti precedentemente
                        inseriti nella propria lista &quot;Preferiti&quot;
                      </li>
                      <li>ogni utente può inviare un massimo di 7 messaggi al giorno</li>
                      <li>
                        il conteggio dei messaggi viene azzerato automaticamente ogni giorno alle ore 00:00
                      </li>
                    </ul>
                    <p>
                      <strong>8.3 Modalità di interazione</strong>
                    </p>
                    <ul>
                      <li>il consulente non è autorizzato ad avviare per primo la conversazione</li>
                      <li>
                        il consulente può rispondere ai messaggi ricevuti entro i limiti temporali della
                        conversazione
                      </li>
                    </ul>
                    <p>
                      <strong>8.4 Durata delle conversazioni</strong>
                    </p>
                    <p>
                      Le conversazioni avviate tramite il sistema di messaggistica hanno una durata
                      limitata, trascorsa la quale non sarà più possibile inviare o ricevere ulteriori
                      messaggi.
                    </p>
                    <p>
                      <strong>8.5 Divieto di utilizzo improprio</strong>
                    </p>
                    <p>
                      È espressamente vietato utilizzare la messaggistica per finalità diverse dalla
                      richiesta di disponibilità del consulente, inclusi a titolo esemplificativo:
                    </p>
                    <ul>
                      <li>lo svolgimento di consulti gratuiti</li>
                      <li>l&apos;invio di contenuti non pertinenti</li>
                      <li>comportamenti abusivi o molesti</li>
                    </ul>
                    <p>
                      Klaro7 si riserva il diritto di limitare o sospendere l&apos;accesso al servizio in
                      caso di utilizzo non conforme.
                    </p>
      
                    <h2>ART. 9 - SISTEMA &quot;PREFERITI&quot;</h2>
                    <p>
                      <strong>9.1 Funzione del servizio</strong>
                    </p>
                    <p>
                      La piattaforma consente all&apos;utente di creare una lista personale di consulenti
                      preferiti, al fine di:
                    </p>
                    <ul>
                      <li>accedere rapidamente ai loro profili</li>
                      <li>monitorarne la disponibilità</li>
                      <li>utilizzare le funzionalità di contatto previste</li>
                    </ul>
                    <p>
                      <strong>9.2 Limite massimo</strong>
                    </p>
                    <p>
                      Ogni utente può inserire un numero massimo di 7 consulenti nella propria lista
                      &quot;Preferiti&quot;.
                    </p>
                    <p>
                      <strong>9.3 Collegamento con la messaggistica</strong>
                    </p>
                    <p>
                      L&apos;invio di messaggi ai consulenti in modalità offline è consentito esclusivamente
                      nei confronti dei consulenti presenti nella lista &quot;Preferiti&quot;.
                    </p>
                    <p>
                      <strong>9.4 Gestione della lista</strong>
                    </p>
                    <p>L&apos;utente può in qualsiasi momento:</p>
                    <ul>
                      <li>aggiungere un consulente ai preferiti</li>
                      <li>rimuovere un consulente dalla lista</li>
                    </ul>
                    <p>Nel rispetto del limite massimo previsto.</p>
                    <p>
                      <strong>9.5 Finalità del sistema</strong>
                    </p>
                    <p>
                      Il limite numerico e le modalità di funzionamento del sistema &quot;Preferiti&quot;
                      sono finalizzati a:
                    </p>
                    <ul>
                      <li>garantire un utilizzo consapevole della piattaforma</li>
                      <li>favorire relazioni continuative tra utente e consulente</li>
                      <li>evitare un uso dispersivo e non mirato del servizio</li>
                    </ul>
      
                    <h2>ART. 10 - CRITERI DI RIMBORSO E RECLAMI</h2>
                    <p>
                      <strong>10.1 Obbligazione di Mezzi:</strong> L&apos;Utilizzatore riconosce che la
                      prestazione dell&apos;Operatore è un&apos;obbligazione di mezzi e non di risultato. Il
                      mancato verificarsi di una previsione o la non condivisione del parere espresso
                      dall&apos;Operatore non costituiscono motivo di rimborso.
                    </p>
                    <p>
                      <strong>10.2 Casi di Rimborso Ammessi:</strong> Il rimborso del credito consumato può
                      essere richiesto esclusivamente nei seguenti casi tecnici o qualitativi gravi:
                    </p>
                    <ul>
                      <li>
                        <strong>Interruzione tecnica:</strong> Caduta della linea o malfunzionamento della
                        piattaforma non imputabile all&apos;utente.
                      </li>
                      <li>
                        <strong>Violazione del Codice Etico:</strong> Comportamento offensivo, volgare o
                        violazione dei divieti (es. diagnosi mediche) da parte dell&apos;Operatore, previa
                        verifica dei log di sistema da parte di Klaro7.
                      </li>
                    </ul>
                    <p>
                      <strong>10.3 Procedura di Reclamo:</strong> Ogni richiesta di rimborso deve essere
                      inviata a assistenza@klaro7.it entro 48 ore dalla fine del consulto. Klaro7 analizzerà
                      la registrazione/chat e comunicherà l&apos;esito entro 5 giorni lavorativi. In caso di
                      accoglimento, il rimborso avverrà esclusivamente sotto forma di Credito Piattaforma
                      (non monetario).
                    </p>
      
                    <h2>ART. 11 - POLICY SUI RIMBORSI, RECLAMI E GESTIONE DISPUTE</h2>
                    <p>
                      <strong>11.1 Obbligazione di Mezzi e non di Risultato</strong> L&apos;Utilizzatore
                      accetta che la prestazione fornita dall&apos;Operatore è di natura intellettuale/
                      esoterica e costituisce un&apos;obbligazione di mezzi. Klaro7 non garantisce la
                      veridicità, l&apos;esattezza o il compimento di quanto predetto o discusso. Pertanto,
                      non è previsto alcun rimborso basato sulla mancata soddisfazione del responso, su
                      opinioni divergenti o sul mancato avverarsi di eventi futuri.
                    </p>
                    <p>
                      <strong>11.2 Casistiche di Rimborso Tecnico (Accettate)</strong> Il rimborso (totale o
                      parziale) dei crediti sarà valutato esclusivamente nelle seguenti ipotesi di
                      malfunzionamento oggettivo:
                    </p>
                    <ul>
                      <li>
                        <strong>Caduta della connessione:</strong> Interruzione della chiamata o della chat
                        dovuta a bug del server di Klaro7 o malfunzionamento della piattaforma.
                      </li>
                      <li>
                        <strong>Addebito errato:</strong> Crediti scalati in assenza di una prestazione
                        effettiva (es. l&apos;operatore non ha risposto ma il tempo è partito).
                      </li>
                      <li>
                        <strong>Audio/Video illeggibile:</strong> Problemi tecnici lato piattaforma che
                        rendono impossibile la comprensione della consulenza sin dai primi secondi.
                      </li>
                    </ul>
                    <p>
                      <strong>11.3 Casistiche di Rimborso Qualitativo e Violazioni (Previa Verifica)</strong>{' '}
                      Il rimborso potrà essere concesso se, dall&apos;analisi dei log/registrazioni, emerge
                      che l&apos;Operatore ha:
                    </p>
                    <ul>
                      <li>Utilizzato un linguaggio volgare, offensivo o discriminatorio.</li>
                      <li>Violato il Codice Etico parlando di salute, morte, gravidanze o minori.</li>
                      <li>Tentato di vendere servizi esterni o richiesto pagamenti fuori dalla piattaforma.</li>
                      <li>
                        Chiuso la comunicazione in modo ingiustificato prima del tempo concordato/pagato
                        senza motivo valido.
                      </li>
                    </ul>
                    <p>
                      <strong>11.4 Casi di Esclusione del Rimborso (Rifiutati)</strong> Nessun rimborso sarà
                      concesso qualora:
                    </p>
                    <ul>
                      <li>
                        L&apos;interruzione dipenda dalla connessione internet o dal dispositivo
                        dell&apos;Utilizzatore.
                      </li>
                      <li>L&apos;Utilizzatore abbia fornito dati errati durante il consulto.</li>
                      <li>Il reclamo venga inviato oltre il termine di 48 ore dalla fine della sessione.</li>
                      <li>
                        L&apos;Utilizzatore abbia tenuto un comportamento provocatorio o offensivo che ha
                        costretto l&apos;Operatore a chiudere la chiamata (in questo caso il credito è
                        perso).
                      </li>
                    </ul>
                    <p>
                      <strong>11.5 Procedura di Reclamo e Analisi</strong> Per attivare la procedura,
                      l&apos;Utilizzatore deve inviare un&apos;email a assistenza@klaro7.it indicando: ID
                      Utente, Nome Operatore, Data/Ora del consulto e motivazione dettagliata. Klaro7 si
                      riserva il diritto di ascoltare le registrazioni o leggere i log della chat per
                      verificare la veridicità del reclamo.
                    </p>
                    <p>
                      <strong>11.6 Modalità di Erogazione (Credito Piattaforma)</strong> In caso di
                      accoglimento del reclamo, il rimborso avverrà esclusivamente tramite il riaccredito di
                      Crediti/Minuti sul profilo dell&apos;Utilizzatore. Non sono ammessi rimborsi monetari
                      (storni su carta di credito o PayPal) per consulti già iniziati, salvo nei casi di
                      legge riguardanti il diritto di recesso su ricariche mai utilizzate (vedi Art. 4.4).
                    </p>
      
                    <h2>ART. 12 - OBBLIGHI, DIVIETI E SANZIONI PER L&apos;UTILIZZATORE</h2>
                    <p>
                      <strong>12.1 Condotta e Rispetto:</strong> L&apos;Utilizzatore si impegna a utilizzare
                      la Piattaforma secondo principi di correttezza, buona fede e rispetto. È severamente
                      vietato adottare comportamenti molesti, offensivi, minacciosi, ingiuriosi o utilizzare
                      un linguaggio volgare, osceno o discriminatorio nei confronti degli Operatori o dello
                      Staff di Klaro7.
                    </p>
                    <p>
                      <strong>12.2 Divieto Assoluto di &quot;Sconfinamento&quot; (Disintermediazione):</strong>{' '}
                      Al fine di tutelare l&apos;integrità commerciale della Piattaforma, è fatto divieto
                      assoluto all&apos;Utilizzatore di:
                    </p>
                    <ul>
                      <li>
                        Richiedere agli Operatori contatti personali (numeri di telefono, email, profili
                        social, indirizzi fisici).
                      </li>
                      <li>
                        Proporre agli Operatori il proseguimento del consulto o il pagamento della
                        prestazione al di fuori dei sistemi ufficiali di Klaro7.
                      </li>
                      <li>
                        Fornire i propri contatti personali agli Operatori con l&apos;intento di essere
                        ricontattati privatamente.
                      </li>
                    </ul>
                    <p>
                      <strong>12.3 Divieto su Tematiche Sensibili e Illecite:</strong> Nel rispetto del
                      Codice Etico di Klaro7, l&apos;Utilizzatore non può richiedere consulti riguardanti:
                    </p>
                    <ul>
                      <li>
                        <strong>Salute:</strong> Diagnosi, prognosi, decorsi di malattie, gravidanze o
                        consigli terapeutici/medici di qualsiasi natura.
                      </li>
                      <li>
                        <strong>Pratiche Esoteriche Illecite:</strong> Rituali di magia nera, malefici,
                        rimozione di malocchi o qualsiasi pratica volta a danneggiare terzi.
                      </li>
                      <li>
                        <strong>Contenuti Espliciti:</strong> Richieste di prestazioni sessualmente esplicite
                        o linguaggio a sfondo erotico.
                      </li>
                      <li>
                        <strong>Minori:</strong> Coinvolgimento di soggetti minorenni nei consulti.
                      </li>
                    </ul>
                    <p>
                      <strong>12.4 Divieto di Registrazione e Diffusione:</strong> È vietato registrare
                      (tramite software o dispositivi esterni), acquisire screenshot o divulgare parzialmente
                      o totalmente il contenuto dei consulti (chat, audio o video) senza il consenso scritto
                      di Klaro7 e dell&apos;Operatore interessato. Ogni violazione sarà perseguita come
                      violazione della privacy e del diritto d&apos;autore.
                    </p>
                    <p>
                      <strong>12.5 Sicurezza e Frodi:</strong> È vietato l&apos;utilizzo di strumenti di
                      pagamento (carte di credito, account PayPal, ecc.) non intestati all&apos;Utilizzatore
                      o di cui non si abbia la legittima disponibilità. Qualsiasi tentativo di frode
                      informatica o di contestazione ingiustificata del pagamento (chargeback) comporterà
                      l&apos;immediata segnalazione alle autorità competenti.
                    </p>
                    <p>
                      <strong>12.6 Sanzioni e Clausola Penale:</strong> La violazione di uno qualsiasi dei
                      divieti sopra elencati conferisce a Klaro7 il diritto di:
                    </p>
                    <ol>
                      <li>
                        Sospendere o eliminare definitivamente l&apos;Account dell&apos;Utilizzatore senza
                        preavviso.
                      </li>
                      <li>
                        Incamerare il credito residuo presente sull&apos;account a titolo di penale
                        risarcitoria, fatto salvo il diritto al risarcimento del maggior danno.
                      </li>
                      <li>
                        Segnalare la condotta alle Autorità qualora si ravvisino estremi di reato (es.
                        truffa, molestie, esercizio abusivo della professione).
                      </li>
                    </ol>
      
                    <h2>ART. 13 - LIMITI DI RESPONSABILITÀ E RUOLO DI INTERMEDIARIO</h2>
                    <p>
                      <strong>13.1 Qualifica di Hosting Provider e Intermediario Tecnico:</strong> Klaro7
                      S.r.l.s. agisce esclusivamente in qualità di fornitore di servizi tecnologici e
                      hosting provider per facilitare l&apos;incontro tra Utilizzatori e Operatori. La
                      Società rimane estranea al rapporto di consulenza che si instaura tra le parti;
                      pertanto, Klaro7 non è parte del contratto di prestazione d&apos;opera intellettuale,
                      che intercorre unicamente ed esclusivamente tra l&apos;Utilizzatore e l&apos;Operatore.
                    </p>
                    <p>
                      <strong>13.2 Esclusione di Responsabilità sui Contenuti:</strong> In virtù del proprio
                      ruolo di intermediario tecnico, Klaro7 non assume alcuna responsabilità in merito a:
                    </p>
                    <ul>
                      <li>
                        La condotta, le opinioni, i consigli, il contenuto o le affermazioni espresse dagli
                        Operatori durante i consulti.
                      </li>
                      <li>
                        L&apos;accuratezza, la veridicità o l&apos;utilità delle informazioni fornite dagli
                        Operatori.
                      </li>
                      <li>
                        Qualsiasi decisione presa dall&apos;Utilizzatore o danno (diretto o indiretto)
                        derivante dall&apos;affidamento riposto nelle informazioni ottenute tramite la
                        Piattaforma.
                      </li>
                    </ul>
                    <p>
                      <strong>13.3 Continuità del Servizio e Cause di Forza Maggiore:</strong> Klaro7 si
                      impegna a mantenere la Piattaforma attiva e funzionale, ma non risponde di guasti,
                      interruzioni o malfunzionamenti derivanti da:
                    </p>
                    <ul>
                      <li>Cause di forza maggiore o caso fortuito.</li>
                      <li>
                        Problemi di connessione internet o malfunzionamenti dei dispositivi
                        dell&apos;Utilizzatore o dell&apos;Operatore.
                      </li>
                      <li>Interventi di manutenzione programmata comunicati con congruo preavviso.</li>
                    </ul>
                    <p>
                      <strong>13.4 Trasparenza e Autenticità delle Recensioni (Direttiva Omnibus):</strong>{' '}
                      In conformità alla normativa vigente, Klaro7 garantisce l&apos;autenticità dei feedback
                      pubblicati. Il sistema abilita il rilascio di una recensione solo ed esclusivamente
                      agli Utilizzatori che hanno effettivamente acquistato e completato un consulto con
                      l&apos;Operatore interessato, impedendo l&apos;inserimento di recensioni fittizie.
                    </p>
                    <p>
                      <strong>13.5 Gestione Reclami e Modalità di Rimborso:</strong>
                    </p>
                    <ul>
                      <li>
                        <strong>Termini:</strong> Eventuali reclami per problemi tecnici oggettivi o
                        violazioni palesi del Codice Etico devono essere inviati a assistenza@klaro7.it entro
                        48 ore dalla fine della sessione.
                      </li>
                      <li>
                        <strong>Analisi:</strong> Klaro7 analizzerà i log della sessione e, qualora
                        riscontrasse una condotta non professionale o un guasto tecnico imputabile al proprio
                        sistema, potrà procedere al rimborso.
                      </li>
                      <li>
                        <strong>Erogazione:</strong> Il rimborso avverrà esclusivamente sotto forma di
                        Credito Piattaforma non monetizzabile. L&apos;Utilizzatore accetta che non sarà
                        erogato alcun rimborso in denaro su carte di credito, PayPal o conti bancari per
                        servizi già parzialmente o totalmente fruiti.
                      </li>
                    </ul>
                    <p>
                      <strong>13.6 Diritto di Rivalsa dell&apos;Operatore:</strong> L&apos;Operatore
                      riconosce a Klaro7 il diritto di procedere alla ripetizione (recupero) di quanto
                      rimborsato all&apos;Utilizzatore qualora il rimborso sia originato da una condotta
                      negligente, dolosa o inadempiente dell&apos;Operatore stesso. In tali casi, Klaro7
                      addebiterà l&apos;intero importo del rimborso (comprensivo di eventuali commissioni di
                      transazione perse) sulle competenze maturate o maturande dell&apos;Operatore.
                    </p>
                    <p>
                      <strong>13.7 Casistiche di Applicazione:</strong> La rivalsa verrà applicata, a titolo
                      esemplificativo ma non esaustivo, nelle seguenti ipotesi:
                    </p>
                    <ul>
                      <li>
                        <strong>Violazione del Codice Etico:</strong> L&apos;Operatore ha trattato temi
                        vietati (salute, gravidanze, investimenti, minori) o ha utilizzato un linguaggio
                        ingiurioso/offensivo.
                      </li>
                      <li>
                        <strong>Mancata Erogazione Tecnica:</strong> L&apos;Operatore ha avviato la sessione
                        ma non ha risposto o ha interrotto volontariamente la comunicazione senza
                        giustificato motivo tecnico.
                      </li>
                      <li>
                        <strong>Sollecitazione Esterna:</strong> L&apos;Operatore ha tentato di scambiare
                        contatti privati o ha invitato l&apos;utente a pagare fuori dalla piattaforma,
                        portando l&apos;utente a segnalare il fatto e chiedere il rimborso del credito
                        residuo.
                      </li>
                      <li>
                        <strong>Qualità Palesemente Insufficiente:</strong> Reclami documentati in cui
                        l&apos;Operatore è rimasto in silenzio per gran parte della sessione o ha palesemente
                        allungato i tempi del consulto senza fornire risposte (frodolenta dilatazione dei
                        tempi).
                      </li>
                    </ul>
                    <p>
                      <strong>13.8 Gestione dei Chargeback (Contestazioni Bancarie):</strong> Qualora un
                      Utilizzatore attivi una procedura di chargeback presso il proprio istituto bancario per
                      un consulto già liquidato all&apos;Operatore, Klaro7 si riserva il diritto di stornare
                      l&apos;importo corrispondente dal primo pagamento utile dell&apos;Operatore,
                      comprensivo delle penali amministrative applicate dai circuiti di pagamento (es.
                      Stripe/PayPal/Bonifico).
                    </p>
                    <p>
                      <strong>13.9 Procedura di Addebito:</strong> L&apos;addebito avverrà tramite
                      compensazione automatica in Dashboard. L&apos;Operatore riceverà una notifica con la
                      motivazione dello storno e il riferimento al consulto contestato.
                    </p>
      
                    <h2>ART. 14 - PRIVACY, RISERVATEZZA E REGISTRAZIONE DEI CONSULTI</h2>
                    <p>
                      <strong>14.1 Protezione dei Dati Personali (GDPR):</strong> Klaro7 S.r.l.s., in
                      qualità di Titolare del Trattamento, garantisce che i dati personali
                      dell&apos;Utilizzatore siano trattati nel pieno rispetto del Regolamento UE 2016/679
                      (GDPR). Le finalità e le modalità del trattamento sono descritte dettagliatamente
                      nell&apos;Informativa Privacy presente sul Sito, che l&apos;Utilizzatore dichiara di
                      aver letto e compreso.
                    </p>
                    <p>
                      <strong>14.2 Confidenzialità e Segreto Professionale:</strong> Klaro7 si impegna a
                      mantenere la massima riservatezza sulle informazioni scambiate durante i consulti. Gli
                      Operatori sono contrattualmente obbligati a rispettare il segreto professionale e non
                      possono divulgare i contenuti delle conversazioni a terzi, salvo obblighi di legge.
                    </p>
                    <p>
                      <strong>14.3 Registrazione delle Conversazioni e Finalità:</strong> L&apos;Utilizzatore
                      prende atto e accetta espressamente che le sessioni di consulto (audio, video o chat)
                      possano essere registrate e conservate sui server della Società. L&apos;accesso a tali
                      registrazioni è limitato esclusivamente al personale autorizzato di Klaro7 per le
                      seguenti finalità:
                    </p>
                    <ul>
                      <li>
                        <strong>Gestione Reclami e Dispute:</strong> Verifica del contenuto in caso di
                        richieste di rimborso o contestazioni.
                      </li>
                      <li>
                        <strong>Controllo Qualità ed Etico:</strong> Monitoraggio a campione per verificare
                        l&apos;osservanza del Codice Etico e della Guida Operativa (es. divieto di parlare di
                        salute o magia nera).
                      </li>
                      <li>
                        <strong>Tutela Giudiziaria:</strong> Adempimento a richieste dell&apos;Autorità
                        Giudiziaria o difesa in sede legale.
                      </li>
                    </ul>
                    <p>
                      <strong>14.4 Consenso alla Registrazione:</strong> Con l&apos;avvio della chiamata o
                      della chat, l&apos;Utilizzatore presta il proprio consenso esplicito alla
                      registrazione. Qualora l&apos;Utilizzatore non desideri essere registrato, deve
                      astenersi dall&apos;utilizzare il Servizio.
                    </p>
                    <p>
                      <strong>14.5 Responsabilità dell&apos;Operatore:</strong> L&apos;Utilizzatore riconosce
                      che l&apos;Operatore è l&apos;unico responsabile per qualsiasi dato personale o sensibile
                      che l&apos;Utilizzatore decida spontaneamente di condividere durante il consulto. Klaro7
                      declina ogni responsabilità per l&apos;uso improprio di tali dati da parte
                      dell&apos;Operatore al di fuori della Piattaforma.
                    </p>
      
                    <h2>ART. 15 - MODIFICHE, LEGGE APPLICABILE E FORO COMPETENTE</h2>
                    <p>
                      <strong>15.1 Modifiche alle CGU:</strong> Klaro7 si riserva il diritto di modificare le
                      presenti CGU in qualsiasi momento per adeguarle a cambiamenti legislativi, evoluzioni
                      tecnologiche o variazioni nel modello di business.
                    </p>
                    <ul>
                      <li>
                        Le modifiche ordinarie saranno comunicate con un preavviso di 15 giorni tramite
                        pubblicazione sul Sito o notifica via email.
                      </li>
                      <li>Le modifiche imposte da leggi o ordini delle Autorità avranno efficacia immediata.</li>
                      <li>
                        L&apos;uso continuativo della Piattaforma dopo la data di entrata in vigore delle
                        modifiche costituisce accettazione delle nuove condizioni.
                      </li>
                    </ul>
                    <p>
                      <strong>15.2 Legge Applicabile:</strong> Le presenti CGU e ogni rapporto tra
                      l&apos;Utilizzatore e Klaro7 sono regolati esclusivamente dalla Legge Italiana.
                    </p>
                    <p>
                      <strong>15.3 Foro Competente (Consumatori):</strong> In conformità con il D.Lgs.
                      206/2005 (Codice del Consumo), per qualsiasi controversia tra l&apos;Utilizzatore
                      (qualificabile come &quot;Consumatore&quot;) e Klaro7, la competenza territoriale
                      inderogabile spetta al Giudice del luogo di residenza o di domicilio
                      dell&apos;Utilizzatore, se ubicati nel territorio dello Stato italiano.
                    </p>
                    <p>
                      <strong>15.4 Foro Esclusivo (Altri Casi):</strong> Per tutte le controversie non
                      rientranti nell&apos;ambito di applicazione del Codice del Consumo (es. Utilizzatori
                      residenti all&apos;estero o che non agiscono in qualità di consumatori), o per ogni
                      altra disputa relativa all&apos;interpretazione ed esecuzione del presente contratto,
                      sarà competente in via esclusiva il Foro di Torino.
                    </p>
                    <p>
                      <strong>15.5 Clausola di Salvaguardia:</strong> Qualora una o più clausole delle
                      presenti CGU venissero dichiarate nulle, annullabili o inapplicabili dall&apos;Autorità
                      Giudiziaria, le restanti clausole rimarranno pienamente valide ed efficaci.
                    </p>
                    <p>
                      <strong>Integrazione di Legge:</strong> Per quanto non espressamente previsto o in caso
                      di lacune derivanti dall&apos;annullamento di una clausola, si applicheranno le
                      disposizioni del Codice Civile e le leggi vigenti in materia di collaborazione
                      autonoma.
                    </p>
    </LegalPageLayout>
  );
}
